<template lang="pug">
.background-transition.py-16.px-2.px-sm-8.px-md-16.d-flex.align-center(
  :class="{ banner3: !isFormSent, banner4: isFormSent }"
  :style="`min-height: calc(100vh - ${$vuetify.application.top}px)`"
)
  v-container(fluid)
    v-row
      transition(name="slow-fade" mode="out-in")
        v-col(v-if="!isFormSent" key="contact-form")
          v-row(justify="center" align="center")
            v-col.text-md-center(cols="auto")
              h2.mb-8.ibm.text-h3.text-md-h2.font-weight-regular.white--text Fale com a gente!
          v-form(v-model="isFormValid")
            v-row(justify="center" align="start")
              v-col(cols=12 md=6 lg=4)
                .mb-2.heebo.text-body-1.white--text Nome e sobrenome
                v-text-field.border--white(
                  v-model="fullName"
                  background-color="grey darken-4"
                  outlined
                  dark
                  :rules="[rules.required]"
                )
                .mb-2.heebo.text-body-1.white--text E-mail
                v-text-field.border--white(
                  v-model="email"
                  background-color="grey darken-4"
                  outlined
                  dark
                  :rules="[rules.required, rules.isValidEmail]"
                )
                .mb-2.heebo.text-body-1.white--text Telefone/Celular
                v-text-field.border--white(
                  v-model="phone"
                  background-color="grey darken-4"
                  outlined
                  dark
                  :rules="[rules.required]"
                )
              v-col(cols=12 md=6 lg=4)
                .mb-2.heebo.text-body-1.white--text Mensagem
                v-textarea.border--white(
                  v-model="message"
                  label="Digite sua mensagem aqui"
                  background-color="grey darken-4"
                  rows=12
                  full-width
                  auto-grow
                  outlined
                  dark
                  :rules="[rules.required]"
                )
          v-row(justify="center" align="center")
            v-col.text-md-center(md="auto")
              v-btn.px-md-16.heebo.text-body-1.font-weight-medium.text-none(
                color="accent"
                depressed
                block
                height=56
                :loading="sendingForm"
                :disabled="!isFormValid"
                @click="sendForm"
              ) Enviar
        v-col(v-if="isFormSent" key="form-sent")
          v-row(justify="center" align="center")
            v-col
              h1.mb-8.mb-md-10.ibm.text-h2.text-md-h1.font-weight-light.white--text Obrigado!
              .mb-8.mb-md-10.heebo.text-h6.text-md-h5.font-weight-regular.white--text(
                style="max-width: 38ch"
              ) Acesse e personalize sua página agora! Qualquer dúvida, basta entrar em contato com a gente.
              v-btn.px-md-16.heebo.text-body-1.font-weight-medium.text-none.primary--text(
                color="white"
                depressed
                :block="$vuetify.breakpoint.xsOnly"
                height=56
                :loading="sendingForm"
                @click="isFormSent = false"
              ) Ir para a minha página!
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isFormValid: false,
      sendingForm: false,
      isFormSent: false,
      fullName: '',
      email: '',
      phone: '',
      message: '',
      rules: {
        required: (v) => !!v || 'Este campo é obrigatório',
        isValidEmail: (v) =>
          /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(
            v
          ) || 'Email inválido'
      }
    }
  },
  methods: {
    async sendForm() {
      try {
        this.sendingForm = true

        const mailData = {
          subject: `${this.fullName} - Contato | Erudio Landing`,
          from: 'Contato | Erudio Landing',
          fullName: this.fullName,
          email: this.email,
          phone: this.phone,
          message: this.message
        }

        await this.$store.dispatch('page/sendForm', {
          to: ['contato@beyondcompany.com.br', 'lapprand@beyondcompany.com.br'],
          template: {
            name: 'erudioLandingContact',
            data: mailData
          }
        })

        this.$analytics.logEvent('landing_form_sent', mailData)

        await this.$goTo({ path: '/contato' })

        this.isFormSent = true
      } catch (error) {
        console.error(error)
        this.$analytics.logEvent('landing_form_send_fail', { error })
      } finally {
        this.sendingForm = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
::v-deep
  .border
    &--white
      // .v-input__slot
      //   border-color: white !important
      fieldset
        border: 1px solid white !important
</style>
